/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Logging Service Icon (`grey-600`) overlaid with MaterialRounded List (`white`) on a `grey-400` background.
 * @export
 */
export const ICON_LOGS_WITH_LIST = (
  <svg fill="none" height="176" viewBox="0 0 177 176" width="177" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 88C0.5 39.3989 39.8989 0 88.5 0C137.101 0 176.5 39.3989 176.5 88V144C176.5 161.673 162.173 176 144.5 176H88.5C39.8989 176 0.5 136.601 0.5 88Z"
      fill="#F5F5F5"
    />
    <path
      clipRule="evenodd"
      d="M63.5 49C57.9772 49 53.5 53.4772 53.5 59V104C53.5 112.284 60.2157 119 68.5 119H113.5C119.023 119 123.5 114.523 123.5 109V64C123.5 55.7157 116.784 49 108.5 49H63.5ZM63.5 69C63.5 66.2386 65.7386 64 68.5 64C71.2614 64 73.5 66.2386 73.5 69V84C73.5 86.7614 71.2614 89 68.5 89C65.7386 89 63.5 86.7614 63.5 84V69ZM73.5 99C73.5 101.761 71.2614 104 68.5 104C65.7386 104 63.5 101.761 63.5 99C63.5 96.2386 65.7386 94 68.5 94C71.2614 94 73.5 96.2386 73.5 99ZM88.5 64C85.7386 64 83.5 66.2386 83.5 69C83.5 71.7614 85.7386 74 88.5 74H108.5C111.261 74 113.5 71.7614 113.5 69C113.5 66.2386 111.261 64 108.5 64H88.5ZM83.5 84C83.5 81.2386 85.7386 79 88.5 79H108.5C111.261 79 113.5 81.2386 113.5 84C113.5 86.7614 111.261 89 108.5 89H88.5C85.7386 89 83.5 86.7614 83.5 84ZM88.5 94C85.7386 94 83.5 96.2386 83.5 99C83.5 101.761 85.7386 104 88.5 104H108.5C111.261 104 113.5 101.761 113.5 99C113.5 96.2386 111.261 94 108.5 94H88.5Z"
      fill="#707070"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M109.683 41.5679C121.419 41.5679 130.933 51.0818 130.933 62.8179L130.933 102.505C130.933 104.576 132.612 106.255 134.683 106.255C136.754 106.255 138.433 104.576 138.433 102.505L138.433 62.8179C138.433 46.9397 125.561 34.0679 109.683 34.0679L60.755 34.0679C58.6839 34.0679 57.005 35.7468 57.005 37.8179C57.005 39.8889 58.6839 41.5679 60.755 41.5679L109.683 41.5679Z"
      fill="#707070"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M67.2734 126.478C55.5374 126.478 46.0234 116.964 46.0234 105.228L46.0234 65.5409C46.0234 63.4699 44.3445 61.7909 42.2734 61.7909C40.2024 61.7909 38.5234 63.4699 38.5234 65.5409L38.5234 105.228C38.5234 121.106 51.3953 133.978 67.2734 133.978L116.202 133.978C118.273 133.978 119.952 132.299 119.952 130.228C119.952 128.157 118.273 126.478 116.202 126.478L67.2734 126.478Z"
      fill="#707070"
      fillRule="evenodd"
    />
    <circle cx="133" cy="132" fill="#F5F5F5" r="29" />
    <path
      d="M132.5 107.833C119.136 107.833 108.333 118.636 108.333 132C108.333 145.364 119.136 156.167 132.5 156.167C145.864 156.167 156.667 145.364 156.667 132C156.667 118.636 145.864 107.833 132.5 107.833Z"
      fill="#BABABA"
    />
    <rect fill="white" height="4" rx="2" width="4" x="119.5" y="122" />
    <rect fill="white" height="4" rx="2" width="4" x="119.5" y="130" />
    <rect fill="white" height="4" rx="2" width="4" x="119.5" y="138" />
    <rect fill="white" height="4" rx="2" width="18" x="127.5" y="122" />
    <rect fill="white" height="4" rx="2" width="18" x="127.5" y="130" />
    <rect fill="white" height="4" rx="2" width="18" x="127.5" y="138" />
  </svg>
);
